import { useTranslation } from 'react-i18next'

import styles from './conversation-header.module.scss'

function ConversationHeader() {
    const { t } = useTranslation()

    return (
        <header className={styles.conversationHeader}>
            <div className={styles.conversationHeader__column}>{t('user')}</div>
            <div className={styles.conversationHeader__column}>
                {t('intent')}
            </div>
            <div className={styles.conversationHeader__column}>{t('bot')}</div>
        </header>
    )
}

export default ConversationHeader
